import { DISPLAY_LANG } from "../../config";
import axios from '../../axios';

export const domainTransferRequiredError = {
    "en": "Please enter your domain name to proceed with the domain transfer.",
    "ru": "Пожалуйста, введите доменное имя для продолжения переноса домена.",
    "am": "Խնդրում ենք մուտքագրել դոմենի անունը՝ դոմենի փոխանցումը շարունակելու համար։"
};

export const domainTransferError = {
    "en": "An error occurred.",
    "ru": "Произошла ошибка.",
    "am": "Տեղի ունեցավ սխալ։"
};

export const noActiveServicesMessage = {
    "en": "There are no active services.",
    "ru": "В настоящее время нет действующих сервисов.",
    "am": "Ակտիվ ծառայություններ չկան։",
};

export const getPageData = async () => {
    const dashboard = await axios.get(`userspagesdata/user_dashboard_data?lang=${DISPLAY_LANG}`);
    const questionHeading = await axios.get('userspagesdata/user_dashboard_page_question_list_heading');
    const questionList = await axios.get(`userspagesdata/user_dashboard_page_question_list?lang=${DISPLAY_LANG}`);

    return {
        pageData: dashboard.data[0],
        question: { heading: questionHeading.data[0], data: questionList.data },
    };
};

export const getUserActiveServicesCount = async () => {
    const reseller_customer_id = localStorage.getItem('reseller_customer_id') ?? '';
    const user_id = localStorage.getItem('user_id') ?? '';

    const response = await axios.get(`users/domain-count?user_id=${user_id}&customer_id=${reseller_customer_id}`);

    if (response.status !== 200){
        throw new Error('Error fetching user active services count');
    }

    const { domain_count, hosting_count, vps_count, ssl_count } = response.data;

    return {
        domains: { type: 'domain', count: domain_count },
        hostings: { type: 'hosting', count: hosting_count },
        ssl: { type: 'ssl', count: ssl_count },
        vps: { type: 'vps', count: vps_count },
    };
};

export const userDomainTransferPost = async (domain) => {
    const cutomer_id = localStorage.getItem('reseller_customer_id');
    const domain_name = domain.split('.').slice(0, -1).join('.');
    const auth_code = domain.split('.').slice(-1)[0];

    const resInfoDomains = await axios.get(
        `contact/default_contacts?customer_id=${cutomer_id}&domain_name=${domain}`
    );

    if (!resInfoDomains.data.ok) {
        throw new Error('Error fetching domain info');
    }

    const data = resInfoDomains.data.data.Contact;
    const order_id = resInfoDomains.data.order_id;

    const body = {
        domain_name,
        auth_code,
        cutomer_id,
        order_id,
        admin_id: data.admin,
        reg_id: data.registrant,
        teach_id: data.tech,
        biling_id: data.billing,
    };

    const res = await axios.post('domain/transfer_domain', body);

    if (!res.data.ok) {
        throw new Error('Error transfer domain');
    }

    return res.data.ok;
};